module.exports = __webpack_public_path__ + "assets/img/30036da91a3ba010f0f675f82f36cc2d.svg";